var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "116px",
    height: "96px",
    viewBox: "0 0 116 96",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 5") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Journey-8---Settings",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "5.3--Data-Processing---dp-yes---library-yes",
    transform: "translate(-679.000000, -551.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(575.000000, 431.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(104.000000, 121.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M116,67.7610619 C116,35.3087965 90.03195,9 58,9 C25.96805,9 0,35.3087965 0,67.7610619 C0,76.4077522 1.8589,84.6093274 5.1678,92 L110.8322,92 C114.1411,84.6093274 116,76.4077522 116,67.7610619",
    id: "Fill-1",
    fill: "#F4F6FC"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(52.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41,4.02995279 C41,1.80367099 39.2523932,0 37.0953117,0 L3.90468832,0 C1.74915203,0 0,1.80367099 0,4.02995279 L0,35.2632829 C0,37.48797 1.74760684,39.2932357 3.90468832,39.2932357 L11.0681767,39.2932357 C11.9643853,39.2932357 12.6906234,40.0427719 12.6906234,40.9677314 L12.6906234,45.3262042 C12.6906234,46.0023815 13.0861913,46.6131737 13.6919047,46.8731192 C14.2991633,47.13147 14.9960428,46.9879418 15.459599,46.5095145 L21.9771991,39.7828264 C22.281601,39.4702538 22.694166,39.2932357 23.123728,39.2932357 L37.0953117,39.2932357 C39.2523932,39.2932357 41,37.48797 41,35.2632829 L41,4.02995279 Z",
    id: "Fill-3",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41,4.02995279 C41,1.80367099 39.2523932,0 37.0953117,0 L3.90468832,0 C1.74915203,0 0,1.80367099 0,4.02995279 L0,35.2632829 C0,37.48797 1.74760684,39.2932357 3.90468832,39.2932357 L11.0681767,39.2932357 C11.9643853,39.2932357 12.6906234,40.0427719 12.6906234,40.9677314 L12.6906234,45.3262042 C12.6906234,46.0023815 13.0861913,46.6131737 13.6919047,46.8731192 C14.2991633,47.13147 14.9960428,46.9879418 15.459599,46.5095145 L21.9771991,39.7828264 C22.281601,39.4702538 22.694166,39.2932357 23.123728,39.2932357 L37.0953117,39.2932357 C39.2523932,39.2932357 41,37.48797 41,35.2632829 L41,4.02995279 Z",
    id: "Stroke-5",
    stroke: "#7450C8",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8358211,29.7346939 L7.16417885,29.7346939 C6.29573394,29.7346939 5.59090909,29.01674 5.59090909,28.1321183 L5.59090909,13.1127797 C5.59090909,12.228158 6.29573394,11.5102041 7.16417885,11.5102041 L33.8358211,11.5102041 C34.7042661,11.5102041 35.4090909,12.228158 35.4090909,13.1127797 L35.4090909,28.1321183 C35.4090909,29.01674 34.7042661,29.7346939 33.8358211,29.7346939",
    id: "Fill-92",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4819775,11.5102041 L7.51648178,11.5102041 C7.13438703,11.5102041 6.80005411,11.6703301 6.52272727,11.9016233 L18.8344983,19.6588398 C19.8590669,20.3041962 21.1393924,20.3041962 22.163961,19.6588398 L34.4772727,11.9016233 C34.1999459,11.6687127 33.8640723,11.5102041 33.4819775,11.5102041",
    id: "Fill-93",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4819775,11.5102041 L7.51648178,11.5102041 C7.13438703,11.5102041 6.80005411,11.6703301 6.52272727,11.9016233 L18.8344983,19.6588398 C19.8590669,20.3041962 21.1393924,20.3041962 22.163961,19.6588398 L34.4772727,11.9016233 C34.1999459,11.6687127 33.8640723,11.5102041 33.4819775,11.5102041 Z",
    id: "Stroke-94",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8358211,29.7346939 L7.16417885,29.7346939 C6.29573394,29.7346939 5.59090909,29.01674 5.59090909,28.1321183 L5.59090909,13.1127797 C5.59090909,12.228158 6.29573394,11.5102041 7.16417885,11.5102041 L33.8358211,11.5102041 C34.7042661,11.5102041 35.4090909,12.228158 35.4090909,13.1127797 L35.4090909,28.1321183 C35.4090909,29.01674 34.7042661,29.7346939 33.8358211,29.7346939 Z",
    id: "Stroke-95",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M85,92.5 C85,93.8809524 72.2401429,95 56.5,95 C40.7598571,95 28,93.8809524 28,92.5 C28,91.1206349 40.7598571,90 56.5,90 C72.2401429,90 85,91.1206349 85,92.5",
    id: "Fill-35",
    fill: "#DFE4EE"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(1.000000, 91.000000)",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L2.8487395,0",
    id: "Stroke-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.151261,0 L113,0",
    id: "Stroke-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.69747899,0 L107.302521,0",
    id: "Stroke-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(37.000000, 56.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.0716264,35 L2.92837357,35 C1.31191136,35 0,33.7618708 0,32.2301361 L0,2.76986388 C0,1.24089902 1.31191136,0 2.92837357,0 L34.0716264,0 C35.6880886,0 37,1.24089902 37,2.76986388 L37,32.2301361 C37,33.7618708 35.6880886,35 34.0716264,35",
    id: "Fill-86",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0716264,35 L2.92837357,35 C1.31191136,35 0,33.7618708 0,32.2301361 L0,2.76986388 C0,1.24089902 1.31191136,0 2.92837357,0 L34.0716264,0 C35.6880886,0 37,1.24089902 37,2.76986388 L37,32.2301361 C37,33.7618708 35.6880886,35 34.0716264,35 Z",
    id: "Stroke-87",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9557956,14.7368421 L14.0705202,14.7368421 C13.2907509,14.7368421 12.6578947,14.1562841 12.6578947,13.4409538 L12.6578947,0 L23.3684211,0 L23.3684211,13.4409538 C23.3684211,14.1562841 22.7355648,14.7368421 21.9557956,14.7368421",
    id: "Fill-90",
    fill: "#DFE4EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9557956,14.7368421 L14.0705202,14.7368421 C13.2907509,14.7368421 12.6578947,14.1562841 12.6578947,13.4409538 L12.6578947,0 L23.3684211,0 L23.3684211,13.4409538 C23.3684211,14.1562841 22.7355648,14.7368421 21.9557956,14.7368421 Z",
    id: "Stroke-91",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup5);
export default __webpack_public_path__ + "static/media/Group_5.9f6a5c314a42da598ed8a0af1f820b3a.svg";
export { ForwardRef as ReactComponent };